import React, { Component } from "react";
import { FaDownload } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "react-select"; // For Select component
// import { getcyclelist } from "store/cycle/actions";
import { updatePayment, deletePayment } from "store/Payment/actions";
import { getdistrictlist } from "store/participantdistrict/actions";
import { getInstrumentReport } from "store/databaseofunits/actions";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import Breadcrumbs from "components/Common/Breadcrumb";
import { getParticipantPayment } from "store/Payment/actions";
// import { getParticipantSchemelist } from "store/Payment/actions";
import "assets/scss/table.scss";
import { Formik, Field, Form, ErrorMessage } from "formik";

class ParticipantPayments extends Component {
  constructor(props) {
    // this.handleSchemeChange = this.handleSchemeChange.bind(this)
    super(props);
    this.state = {
      nameFilter: "",
      idFilter: "",
      districtFilter: "",
      schemeFilter: "",
      schemeModalOpen: false,
      amountFilter: "",
      discountFilter: "",
      schemepriceFilter: "",
      hoveredSchemeNames: [],
      selectedScheme: null,
      selectedCycle: "",
      reportFilterType: "", // dropdown selection
      reportFilterValue: "", // search text
      CycleList: [],
      ListDistrict: [],
      hoveredSchemeNames: [],
      InstrumentReport: [],
      selectedSchemeRounds: [],
      InstrumentReportDetail: [],
      selectedCheckboxes: {},
      GetPayment: [],
      tableKey: 0,
      feedbackMessage: "",
      errorMessage: "",
      editModalOpen: false,
      selectedRow: null,
      feedbackListColumns: [
        {
          dataField: "equipment",
          text: "Equipment",
          sort: true,
          style: { textAlign: "left" },
          formatter: (cell) => cell || "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.equipmentFilter}
                  onChange={(e) =>
                    this.handleFilterChange("equipmentFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },

        {
          dataField: "instrument_type",
          text: "Equipment Type",
          sort: true,
          style: { textAlign: "left" },
          formatter: (cell) => cell || "NS", // ✅ Just display the string as-is
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.equipmentTypeFilter}
                  onChange={(e) =>
                    this.handleFilterChange("equipmentTypeFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },

        {
          dataField: "manufacturer",
          text: "Manufacturer",
          sort: true,
          style: { textAlign: "left" },
          formatter: (cell) => cell || "NS", // ✅ No parsing needed
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.manufacturerFilter}
                  onChange={(e) =>
                    this.handleFilterChange("manufacturerFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },

        {
          dataField: "origin",
          text: "Origin",
          sort: true,
          style: { textAlign: "left" },
          formatter: (cell) => cell || "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.originFilter}
                  onChange={(e) => this.handleFilterChange("originFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
      ],
    };
  }
  componentDidMount() {
    // ✅ 1. Restore filters from localStorage (if present)
    const savedFilters = localStorage.getItem("participantPaymentsFilters");
    if (savedFilters) {
      try {
        const parsed = JSON.parse(savedFilters);
        this.setState({ ...parsed });
      } catch (e) {
        console.error("Failed to parse saved filters:", e);
      }
    }

    // ✅ 2. Existing logic for fetching data
    const {
      onGetParticipantpayment,
      // ongetcyclelist,
      onGetDistrictList,
      onGetInstrumentReportList,
    } = this.props;

    onGetParticipantpayment();

    const authUser = localStorage.getItem("authUser");
    const user_id = authUser ? JSON.parse(authUser).user_id : null;

    if (user_id) {
      // ongetcyclelist(user_id);

      this.setState({ user_id }, () => {
        onGetDistrictList(this.state.user_id);

        const { organization_name } = this.props.match.params || {};

        if (organization_name) {
          this.setState({ organization_name }, () => {
            this.fetchData(this.state.user_id);
            onGetInstrumentReportList(user_id);
          });
        }
      });
    }
  }
  componentWillUnmount() {
    // 🧹 Clear the filters when leaving this page
    localStorage.removeItem("participantPaymentsFilters");
  }
  fetchData(user_id) {
    const { onGetParticipantpayment } = this.props;

    // Call participant payment API
    onGetParticipantpayment();
  }
  handleSchemeChange = (event) => {
    const selectedScheme = event.target.value;

    this.setState({ selectedScheme }, () => {
      this.applyFilters(); // Call filters after updating state
    });
  };
  componentDidUpdate(prevProps, prevState) {
    // 1) When InstrumentReportDetail prop changes, stash raw instruments & schemes
    if (
      this.props.InstrumentReportDetail !== prevProps.InstrumentReportDetail
    ) {
      const instruments = this.props.InstrumentReportDetail?.instruments || [];
      const schemes = this.props.InstrumentReportDetail?.schemes || [];

      this.setState({
        InstrumentReportDetail: instruments,
        InstrumentSchemes: schemes,
      });
    }

    // Helper: check if instrument matches by id or by name
    const instrumentMatches = (instObj, instrument) => {
      if (!instObj || !instrument) return false;
      if (instObj.id != null && instrument.id != null) {
        return Number(instObj.id) === Number(instrument.id);
      }
      return (
        (instObj.name || "").trim().toLowerCase() ===
        (instrument.name || "").trim().toLowerCase()
      );
    };

    // 2) Recompute rows if payload or scheme filter changed
    const payloadChanged =
      this.props.InstrumentReportDetail !== prevProps.InstrumentReportDetail;
    const schemeChanged = this.state.schemeFilter !== prevState.schemeFilter;

    if (payloadChanged || schemeChanged) {
      const instruments = this.props.InstrumentReportDetail?.instruments || [];
      const schemes = this.props.InstrumentReportDetail?.schemes || [];

      // Determine selected scheme
      const selectedSchemeName = this.state.schemeFilter || "";
      const selectedScheme =
        schemes.find((s) => (s.name || "") === selectedSchemeName) || null;

      // Get rounds for this scheme
      const rounds = Array.isArray(selectedScheme?.rounds)
        ? selectedScheme.rounds
        : [];

      // Build table rows
      // Build table rows
      const transformedData = instruments.map((instrument) => {
        // Collect all unique districts for this instrument across all rounds
        const districtsSet = new Set();
        rounds.forEach((rnd) => {
          (rnd.participants || []).forEach((p) => {
            const insts = Array.isArray(p.instruments) ? p.instruments : [];
            if (
              insts.some((instObj) => instrumentMatches(instObj, instrument))
            ) {
              if (p.district && p.district !== "undefined") {
                districtsSet.add(p.district);
              }
            }
          });
        });
        const participantDistrict = districtsSet.size
          ? Array.from(districtsSet).join(", ")
          : "NS";

        const row = {
          equipment: instrument.name || "NS",
          instrument_type:
            instrument.instrument_type ||
            instrument.instrument_type_name ||
            "NS",
          manufacturer:
            instrument.manufacturer || instrument.manufacturer_name || "NS",
          origin: instrument.origin || instrument.country_name || "NS",
          district: participantDistrict, // ✅ All districts in one field
          lastround: instrument.last_round || "NS",
        };

        // Attach participant names for each round (optional: without district)
        rounds.forEach((rnd) => {
          const seen = new Set();
          const participantsForThisInstrument = (rnd.participants || [])
            .filter((p) => {
              const insts = Array.isArray(p.instruments) ? p.instruments : [];
              if (insts.length === 0) return false;
              return insts.some((instObj) =>
                instrumentMatches(instObj, instrument)
              );
            })
            .filter((p) => {
              if (seen.has(p.id)) return false;
              seen.add(p.id);
              return true;
            })
            .map((p) => ({
              participant_id: p.id,
              name: p.name || "Unknown",
              district: p.district || "NS",
              round_id: rnd.id,
              cycle_no: rnd.cycle_no || null,
              scheme_type:
                selectedScheme?.analytetype || rnd.scheme_type || "Unknown",
            }));

          // ✅ Use round ID or cycle_no as the key, not array index
          const key = `round_${rnd.id}`;
          row[key] = {
            roundInfo: rnd,
            count: participantsForThisInstrument.length,
            participants: participantsForThisInstrument,
          };
        });

        return row;
      });

      // Deduplicate rounds by cycle_no or id
      const uniqueRounds = Array.isArray(rounds)
        ? rounds.filter(
            (r, index, self) => index === self.findIndex((rr) => rr.id === r.id)
          )
        : [];

      this.setState({
        InstrumentSchemes: schemes,
        selectedSchemeRounds: uniqueRounds, // ✅ deduplicated
        GetPayment: transformedData,
      });
    }

    // 3) District list update
    if (prevProps.ListDistrict !== this.props.ListDistrict) {
      this.setState({ ListDistrict: this.props.ListDistrict });
    }
  }

  handleSchemeClick = (row) => {
    this.setState({
      hoveredSchemeNames: row.scheme_names || [],
      schemeModalOpen: true,
      modalParticipantName: row.participant_name || "", // ✅ Matches modal
    });
  };

  handleSchemeModalClose = () => {
    this.setState({
      schemeModalOpen: false,
    });
  };

  handleMouseExit = () => {
    this.setState({
      PatientModal: false,
      MarketerModal: false,
      LabModal: false,
      isHovered: false,
    });
  };
  handleFilterChange = (filterName, e) => {
    const value = e.target.value;

    this.setState(
      (prevState) => {
        const newState = { ...prevState, [filterName]: value };

        // Hierarchical reset logic
        switch (filterName) {
          case "equipmentTypeFilter":
            // If "All Types" is selected → clear everything below
            if (value === "") {
              newState.manufacturerFilter = "";
              newState.equipmentFilter = "";
              newState.originFilter = "";
            }
            break;

          case "manufacturerFilter":
            // If "All Manufacturers" → clear only below, NOT above
            if (value === "") {
              newState.equipmentFilter = "";
              // originFilter stays as is (e.g. China), so we can get all manufacturers from China
            }
            break;

          case "equipmentFilter":
            // Just clear equipment itself
            break;

          case "originFilter":
            // If "All Country" → clear only itself, NOT manufacturer/equipment above
            break;

          case "schemeFilter":
            // If "All Schemes" selected → clear cycle as well
            if (value === "") {
              newState.selectedCycle = "";
            }
            break;

          case "selectedCycle":
            // Just clears cycle
            break;

          default:
            break;
        }

        return newState;
      },
      () => {
        // ✅ Persist filters after updates
        const {
          reportFilterType,
          equipmentFilter,
          equipmentTypeFilter,
          manufacturerFilter,
          originFilter,
          schemeFilter,
          selectedCycle,
        } = this.state;

        const filtersToSave = {
          reportFilterType,
          equipmentFilter,
          equipmentTypeFilter,
          manufacturerFilter,
          originFilter,
          schemeFilter,
          selectedCycle,
        };

        localStorage.setItem(
          "participantPaymentsFilters",
          JSON.stringify(filtersToSave)
        );
      }
    );
  };

  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };
  filterData = () => {
    const {
      GetPayment,
      districtFilter = "",
      equipmentFilter = "",
      equipmentTypeFilter = "",
      manufacturerFilter = "",
      originFilter = "",
      lastroundFilter = "",
      selectedCycle,
      reportFilterType,
      reportFilterValue,
    } = this.state;

    return GetPayment.filter((entry) => {
      const matchesBasic =
        (entry.district || "")
          .toLowerCase()
          .includes(districtFilter.toLowerCase()) &&
        (entry.equipment || "")
          .toLowerCase()
          .includes(equipmentFilter.toLowerCase()) &&
        (entry.instrument_type || "")
          .toLowerCase()
          .includes(equipmentTypeFilter.toLowerCase()) &&
        (entry.manufacturer || "")
          .toLowerCase()
          .includes(manufacturerFilter.toLowerCase()) &&
        (entry.origin || "")
          .toLowerCase()
          .includes(originFilter.toLowerCase()) &&
        String(entry.lastround || "")
          .toLowerCase()
          .includes(lastroundFilter.toLowerCase());

      if (!matchesBasic) return false;

      // ✅ Apply Report Name Filter
      if (reportFilterType && reportFilterValue) {
        const fieldValue = (entry[reportFilterType] || "").toLowerCase();
        if (!fieldValue.includes(reportFilterValue.toLowerCase())) {
          return false;
        }
      }

      // ✅ Filter by cycle (if applied)
      if (selectedCycle) {
        return Object.keys(entry).some(
          (k) =>
            k.startsWith("round_") &&
            entry[k]?.participants?.some(
              (p) =>
                String(p.round_id) === String(selectedCycle) ||
                String(p.cycle_no) === String(selectedCycle)
            )
        );
      }

      return true;
    });
  };

  getUniqueOptions = (fieldName) => {
    // Always use full data, not filtered
    const allData = this.state.GetPayment || [];
    const options = new Set();

    allData.forEach((item) => {
      const value = item[fieldName];
      if (Array.isArray(value)) {
        value.forEach((v) => options.add(v));
      } else if (value) {
        options.add(value);
      }
    });

    return Array.from(options);
  };
  getFilteredOptions = (fieldName) => {
    const {
      GetPayment,
      equipmentTypeFilter,
      manufacturerFilter,
      originFilter,
    } = this.state;

    // Start with all rows
    let filtered = GetPayment;

    // Filter by equipment type if selected
    if (equipmentTypeFilter) {
      filtered = filtered.filter(
        (item) =>
          (item.instrument_type || "").toLowerCase() ===
          equipmentTypeFilter.toLowerCase()
      );
    }

    // Filter by manufacturer if selected (for subsequent filters)
    if (manufacturerFilter && fieldName !== "manufacturer") {
      filtered = filtered.filter(
        (item) =>
          (item.manufacturer || "").toLowerCase() ===
          manufacturerFilter.toLowerCase()
      );
    }

    // Filter by origin if selected (for subsequent filters)
    if (originFilter && fieldName !== "origin") {
      filtered = filtered.filter(
        (item) =>
          (item.origin || "").toLowerCase() === originFilter.toLowerCase()
      );
    }

    // Collect unique values of the requested field
    const optionsSet = new Set();
    filtered.forEach((item) => {
      const val = item[fieldName];
      if (val) optionsSet.add(val);
    });

    return Array.from(optionsSet).map((option) => ({
      value: option,
      label: option,
    }));
  };

  checkFiltersApplied = () => {
    const {
      nameFilter,
      idFilter,
      districtFilter,
      schemeFilter,
      schemepriceFilter,
    } = this.state;

    // Check if ANY filter is applied AND has a NON-EMPTY value
    const filters = [
      nameFilter,
      idFilter,
      districtFilter,
      schemeFilter,
      schemepriceFilter,
    ];

    const anyFilterSelected = filters.some((f) => f && f.trim() !== "");

    this.setState({ filtersApplied: anyFilterSelected });
  };

  render() {
    const { GetPayment } = this.state;
    const defaultSorted = [{ dataField: "id", order: "desc" }];
    const { ListDistrict } = this.state;
    const districtOptions = ListDistrict.map((district) => ({
      value: district.name,
      label: district.name,
    }));
    const filteredData = this.filterData();
    const pageOptions = {
      sizePerPage: 50,
      totalSize: filteredData.length, // ✅ fixes extra pagination pages
      custom: true,
    };

    // ✅ Sort rounds to ensure consistent column order
    const sortedRounds = [...(this.state.selectedSchemeRounds || [])].sort(
      (a, b) => a.id - b.id
    );
    const sortedData = [...filteredData].sort((a, b) => {
      const aVal = (a.equipment || "").toLowerCase();
      const bVal = (b.equipment || "").toLowerCase();
      return aVal.localeCompare(bVal); // A → Z
    });
    const roundColumns = sortedRounds.map((round) => ({
      dataField: `round_${round.id}`, // unique ID for data field
      text: `Round (${round.rounds || round.round_no || round.id})`,
      sort: true,
      sortFunc: (a, b, order) => {
        const aCount = a ? a.count || 0 : 0;
        const bCount = b ? b.count || 0 : 0;
        if (order === "asc") return aCount - bCount;
        return bCount - aCount;
      },
      style: { textAlign: "center" },
      formatter: (cell) => {
        if (!cell || cell.count === 0) return "NS";
        return (
          <span
            style={{
              color: "blue",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() =>
              this.setState({
                schemeModalOpen: true,
                modalParticipantName: `Round (${
                  round.rounds || round.round_no || round.id
                })`,
                hoveredSchemeNames: cell.participants || [],
              })
            }
          >
            {cell.count}
          </span>
        );
      },
      headerFormatter: (column) => (
        <div style={{ textAlign: "center" }}>{column.text}</div>
      ),
    }));

    const allColumns = [...this.state.feedbackListColumns, ...roundColumns];

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Participant Payment | NHS NEQAS</title>
          </MetaTags>

          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Labs" breadcrumbItem="EQUIPMENT REPORT - 1" />
            <Row className="justify-content-center align-item-center">
              <Col lg="10">
                {" "}
                {/* <p>
                  <strong>Note:</strong> Click on Scheme Number to get detail of
                  each participants payments
                </p> */}
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.feedbackListColumns}
                      data={filteredData} // ✅ use filtered data
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={allColumns}
                          data={filteredData} // ✅ use same here
                          search
                        >
                          {(toolkitprops) => (
                            <React.Fragment>
                              <Modal
                                isOpen={this.state.schemeModalOpen}
                                toggle={this.handleSchemeModalClose}
                              >
                                <ModalHeader
                                  toggle={this.handleSchemeModalClose}
                                >
                                  Scheme Details for{" "}
                                  {this.state.modalParticipantName || "Unknown"}
                                </ModalHeader>
                                <ModalBody>
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th className="text-start">
                                          Participant ID
                                        </th>
                                        <th className="text-start">
                                          Participant Name
                                        </th>
                                        <th className="text-start">District</th>
                                        <th className="text-start">Report</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(
                                        this.state.hoveredSchemeNames || []
                                      ).map((p, idx) => (
                                        <tr key={idx}>
                                          <td className="text-start">
                                            {p.participant_id}
                                          </td>
                                          <td className="text-start">
                                            {p.name}
                                          </td>
                                          <td className="text-start">
                                            {p.district}
                                          </td>
                                          <td className="text-start">
                                            {console.log(
                                              "Link params:",
                                              this.state.organization_name,
                                              p.round_id,
                                              p.participant_id
                                            )}
                                            <Tooltip title="View Report">
                                              {p.scheme_type ===
                                              "Quantitative" ? (
                                                <Link
                                                  to={`/${this.state.organization_name}/${p.round_id}/${p.participant_id}/report1_view`}
                                                >
                                                  <i className="fas fa-file-alt text-primary font-size-18"></i>
                                                </Link>
                                              ) : p.scheme_type ===
                                                "Qualitative" ? (
                                                <Link
                                                  to={`/${this.state.organization_name}/${p.round_id}/${p.participant_id}/qualitative_report_db`}
                                                >
                                                  <i className="fas fa-file-alt text-success font-size-18"></i>
                                                </Link>
                                              ) : p.scheme_type ===
                                                "Identification" ? (
                                                <Link
                                                  to={`/${this.state.organization_name}/${p.round_id}/${p.participant_id}/micro-report`}
                                                >
                                                  <i className="fas fa-file-alt text-warning font-size-18"></i>
                                                </Link>
                                              ) : null}
                                            </Tooltip>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </ModalBody>
                              </Modal>
                              <Row className="mb-3">
                                {/* Report Filter Type */}
                                <Col md={4}>
                                  <Label for="reportFilterType">
                                    Report Name Filter
                                  </Label>
                                  <Select
                                    id="reportFilterType"
                                    options={[
                                      {
                                        value: "instrument_type",
                                        label: "Search by Type",
                                      },
                                      {
                                        value: "manufacturer",
                                        label: "Search by Manufacturer",
                                      },
                                      {
                                        value: "equipment",
                                        label: "Search by Equipment",
                                      },
                                      {
                                        value: "origin",
                                        label: "Search by Country of Origin",
                                      },
                                    ]}
                                    value={
                                      this.state.reportFilterType
                                        ? {
                                            value: this.state.reportFilterType,
                                            label: {
                                              instrument_type: "Search by Type",
                                              manufacturer:
                                                "Search by Manufacturer",
                                              equipment: "Search by Equipment",
                                              origin:
                                                "Search by Country of Origin",
                                            }[this.state.reportFilterType],
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      this.setState({
                                        reportFilterType: selected?.value || "",
                                        manufacturerFilter: "",
                                        equipmentFilter: "",
                                        originFilter: "",
                                        equipmentTypeFilter: "",
                                      })
                                    }
                                    isClearable
                                  />
                                </Col>

                                {/* ======================= FILTERS BY TYPE ======================= */}
                                {this.state.reportFilterType ===
                                  "instrument_type" && (
                                  <>
                                    <Col md={4}>
                                      <Label for="equipmentTypeFilter">
                                        Equipment Type
                                      </Label>
                                      <Select
                                        id="equipmentTypeFilter"
                                        options={[
                                          { value: "All", label: "All Types" },
                                          ...this.getFilteredOptions(
                                            "instrument_type"
                                          ),
                                        ]}
                                        value={
                                          this.state.equipmentTypeFilter === ""
                                            ? {
                                                value: "All",
                                                label: "All Types",
                                              }
                                            : this.state.equipmentTypeFilter
                                            ? {
                                                value:
                                                  this.state
                                                    .equipmentTypeFilter,
                                                label:
                                                  this.state
                                                    .equipmentTypeFilter,
                                              }
                                            : null
                                        }
                                        onChange={(selected) =>
                                          this.handleFilterChange(
                                            "equipmentTypeFilter",
                                            {
                                              target: {
                                                value:
                                                  selected?.value === "All"
                                                    ? ""
                                                    : selected?.value || "",
                                              },
                                            }
                                          )
                                        }
                                        isClearable
                                      />
                                    </Col>

                                    <Col md={4}>
                                      <Label for="manufacturerFilter">
                                        Manufacturer
                                      </Label>
                                      <Select
                                        id="manufacturerFilter"
                                        options={[
                                          {
                                            value: "All",
                                            label: "All Manufacturers",
                                          },
                                          ...this.getFilteredOptions(
                                            "manufacturer"
                                          ),
                                        ]}
                                        value={
                                          this.state.manufacturerFilter === ""
                                            ? {
                                                value: "All",
                                                label: "All Manufacturers",
                                              }
                                            : this.state.manufacturerFilter
                                            ? {
                                                value:
                                                  this.state.manufacturerFilter,
                                                label:
                                                  this.state.manufacturerFilter,
                                              }
                                            : null
                                        }
                                        onChange={(selected) =>
                                          this.handleFilterChange(
                                            "manufacturerFilter",
                                            {
                                              target: {
                                                value:
                                                  selected?.value === "All"
                                                    ? ""
                                                    : selected?.value || "",
                                              },
                                            }
                                          )
                                        }
                                        isClearable
                                      />
                                    </Col>

                                    <Col md={4}>
                                      <Label for="equipmentFilter">
                                        Equipment
                                      </Label>
                                      <Select
                                        id="equipmentFilter"
                                        options={[
                                          {
                                            value: "All",
                                            label: "All Equipment",
                                          },
                                          ...this.getFilteredOptions(
                                            "equipment"
                                          ),
                                        ]}
                                        value={
                                          this.state.equipmentFilter === ""
                                            ? {
                                                value: "All",
                                                label: "All Equipment",
                                              }
                                            : this.state.equipmentFilter
                                            ? {
                                                value:
                                                  this.state.equipmentFilter,
                                                label:
                                                  this.state.equipmentFilter,
                                              }
                                            : null
                                        }
                                        onChange={(selected) =>
                                          this.handleFilterChange(
                                            "equipmentFilter",
                                            {
                                              target: {
                                                value:
                                                  selected?.value === "All"
                                                    ? ""
                                                    : selected?.value || "",
                                              },
                                            }
                                          )
                                        }
                                        isClearable
                                      />
                                    </Col>
                                  </>
                                )}

                                {/* ======================= FILTERS BY MANUFACTURER ======================= */}
                                {this.state.reportFilterType ===
                                  "manufacturer" && (
                                  <>
                                    <Col md={4}>
                                      <Label for="manufacturerFilter">
                                        Manufacturer
                                      </Label>
                                      <Select
                                        id="manufacturerFilter"
                                        options={[
                                          {
                                            value: "All",
                                            label: "All Manufacturers",
                                          },
                                          ...this.getFilteredOptions(
                                            "manufacturer"
                                          ),
                                        ]}
                                        value={
                                          this.state.manufacturerFilter === ""
                                            ? {
                                                value: "All",
                                                label: "All Manufacturers",
                                              }
                                            : this.state.manufacturerFilter
                                            ? {
                                                value:
                                                  this.state.manufacturerFilter,
                                                label:
                                                  this.state.manufacturerFilter,
                                              }
                                            : null
                                        }
                                        onChange={(selected) =>
                                          this.handleFilterChange(
                                            "manufacturerFilter",
                                            {
                                              target: {
                                                value:
                                                  selected?.value === "All"
                                                    ? ""
                                                    : selected?.value || "",
                                              },
                                            }
                                          )
                                        }
                                        isClearable
                                      />
                                    </Col>

                                    <Col md={4}>
                                      <Label for="equipmentFilter">
                                        Equipment
                                      </Label>
                                      <Select
                                        id="equipmentFilter"
                                        options={[
                                          {
                                            value: "All",
                                            label: "All Equipment",
                                          },
                                          ...this.getFilteredOptions(
                                            "equipment"
                                          ),
                                        ]}
                                        value={
                                          this.state.equipmentFilter === ""
                                            ? {
                                                value: "All",
                                                label: "All Equipment",
                                              }
                                            : this.state.equipmentFilter
                                            ? {
                                                value:
                                                  this.state.equipmentFilter,
                                                label:
                                                  this.state.equipmentFilter,
                                              }
                                            : null
                                        }
                                        onChange={(selected) =>
                                          this.handleFilterChange(
                                            "equipmentFilter",
                                            {
                                              target: {
                                                value:
                                                  selected?.value === "All"
                                                    ? ""
                                                    : selected?.value || "",
                                              },
                                            }
                                          )
                                        }
                                        isClearable
                                      />
                                    </Col>
                                  </>
                                )}

                                {/* ======================= FILTERS BY EQUIPMENT ======================= */}
                                {this.state.reportFilterType ===
                                  "equipment" && (
                                  <Col md={4}>
                                    <Label for="equipmentFilter">
                                      Equipment
                                    </Label>
                                    <Select
                                      id="equipmentFilter"
                                      options={[
                                        {
                                          value: "All",
                                          label: "All Equipment",
                                        },
                                        ...this.getFilteredOptions("equipment"),
                                      ]}
                                      value={
                                        this.state.equipmentFilter === ""
                                          ? {
                                              value: "All",
                                              label: "All Equipment",
                                            }
                                          : this.state.equipmentFilter
                                          ? {
                                              value: this.state.equipmentFilter,
                                              label: this.state.equipmentFilter,
                                            }
                                          : null
                                      }
                                      onChange={(selected) =>
                                        this.handleFilterChange(
                                          "equipmentFilter",
                                          {
                                            target: {
                                              value:
                                                selected?.value === "All"
                                                  ? ""
                                                  : selected?.value || "",
                                            },
                                          }
                                        )
                                      }
                                      isClearable
                                    />
                                  </Col>
                                )}

                                {/* ======================= FILTERS BY COUNTRY (ORIGIN) ======================= */}
                                {this.state.reportFilterType === "origin" && (
                                  <>
                                    <Col md={4}>
                                      <Label for="originFilter">
                                        Country of Origin
                                      </Label>
                                      <Select
                                        id="originFilter"
                                        options={[
                                          {
                                            value: "All",
                                            label: "All Countries",
                                          },
                                          ...this.getFilteredOptions("origin"),
                                        ]}
                                        value={
                                          this.state.originFilter === ""
                                            ? {
                                                value: "All",
                                                label: "All Countries",
                                              }
                                            : this.state.originFilter
                                            ? {
                                                value: this.state.originFilter,
                                                label: this.state.originFilter,
                                              }
                                            : null
                                        }
                                        onChange={(selected) =>
                                          this.handleFilterChange(
                                            "originFilter",
                                            {
                                              target: {
                                                value:
                                                  selected?.value === "All"
                                                    ? ""
                                                    : selected?.value || "",
                                              },
                                            }
                                          )
                                        }
                                        isClearable
                                      />
                                    </Col>

                                    <Col md={4}>
                                      <Label for="manufacturerFilter">
                                        Manufacturer
                                      </Label>
                                      <Select
                                        id="manufacturerFilter"
                                        options={[
                                          {
                                            value: "All",
                                            label: "All Manufacturers",
                                          },
                                          ...this.getFilteredOptions(
                                            "manufacturer"
                                          ),
                                        ]}
                                        value={
                                          this.state.manufacturerFilter === ""
                                            ? {
                                                value: "All",
                                                label: "All Manufacturers",
                                              }
                                            : this.state.manufacturerFilter
                                            ? {
                                                value:
                                                  this.state.manufacturerFilter,
                                                label:
                                                  this.state.manufacturerFilter,
                                              }
                                            : null
                                        }
                                        onChange={(selected) =>
                                          this.handleFilterChange(
                                            "manufacturerFilter",
                                            {
                                              target: {
                                                value:
                                                  selected?.value === "All"
                                                    ? ""
                                                    : selected?.value || "",
                                              },
                                            }
                                          )
                                        }
                                        isClearable
                                      />
                                    </Col>

                                    <Col md={4}>
                                      <Label for="equipmentFilter">
                                        Equipment
                                      </Label>
                                      <Select
                                        id="equipmentFilter"
                                        options={[
                                          {
                                            value: "All",
                                            label: "All Equipment",
                                          },
                                          ...this.getFilteredOptions(
                                            "equipment"
                                          ),
                                        ]}
                                        value={
                                          this.state.equipmentFilter === ""
                                            ? {
                                                value: "All",
                                                label: "All Equipment",
                                              }
                                            : this.state.equipmentFilter
                                            ? {
                                                value:
                                                  this.state.equipmentFilter,
                                                label:
                                                  this.state.equipmentFilter,
                                              }
                                            : null
                                        }
                                        onChange={(selected) =>
                                          this.handleFilterChange(
                                            "equipmentFilter",
                                            {
                                              target: {
                                                value:
                                                  selected?.value === "All"
                                                    ? ""
                                                    : selected?.value || "",
                                              },
                                            }
                                          )
                                        }
                                        isClearable
                                      />
                                    </Col>
                                  </>
                                )}

                                {/* ======================= SCHEME & CYCLE FILTERS ======================= */}
                                <Col md={4}>
                                  <Label for="schemeFilter">Scheme</Label>
                                  <Select
                                    id="schemeFilter"
                                    options={[
                                      { value: "All", label: "All Schemes" },
                                      ...(
                                        this.state.InstrumentSchemes || []
                                      ).map((option) => ({
                                        value: option.name,
                                        label: option.name,
                                      })),
                                    ]}
                                    value={
                                      this.state.schemeFilter === ""
                                        ? { value: "All", label: "All Schemes" }
                                        : this.state.schemeFilter
                                        ? {
                                            value: this.state.schemeFilter,
                                            label: this.state.schemeFilter,
                                          }
                                        : null
                                    }
                                    onChange={(selected) => {
                                      const value =
                                        selected?.value === "All"
                                          ? ""
                                          : selected?.value || "";
                                      this.handleFilterChange("schemeFilter", {
                                        target: { value },
                                      });
                                      this.setState({
                                        selectedScheme: value || null,
                                        selectedCycle: "",
                                      });
                                    }}
                                    isClearable
                                  />
                                </Col>

                                {this.state.selectedScheme && (
                                  <Col md={4}>
                                    <Label for="cycleFilter">Cycle</Label>
                                    <Select
                                      id="cycleFilter"
                                      options={[
                                        { value: "All", label: "All Cycles" },
                                        ...[
                                          ...new Map(
                                            (
                                              this.state.selectedSchemeRounds ||
                                              []
                                            ).map((r) => [
                                              r.cycle_no || r.id,
                                              r,
                                            ])
                                          ).values(),
                                        ].map((round) => ({
                                          value: round.cycle_no || round.id,
                                          label: round.cycle_no
                                            ? `Cycle ${round.cycle_no}`
                                            : `Round ${round.id}`,
                                        })),
                                      ]}
                                      value={
                                        this.state.selectedCycle === ""
                                          ? {
                                              value: "All",
                                              label: "All Cycles",
                                            }
                                          : this.state.selectedCycle
                                          ? {
                                              value: this.state.selectedCycle,
                                              label: `Cycle ${this.state.selectedCycle}`,
                                            }
                                          : null
                                      }
                                      onChange={(selected) =>
                                        this.handleFilterChange(
                                          "selectedCycle",
                                          {
                                            target: {
                                              value:
                                                selected?.value === "All"
                                                  ? ""
                                                  : selected?.value || "",
                                            },
                                          }
                                        )
                                      }
                                      isClearable
                                    />
                                  </Col>
                                )}
                              </Row>

                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-condensed table-hover"
                                      }
                                      bordered={false}
                                      striped={true}
                                      data={sortedData}
                                      headerWrapperClasses={
                                        "table-header-sky-blue"
                                      }
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ParticipantPayments.propTypes = {
  GetPayment: PropTypes.array,
  CycleList: PropTypes.array,
  InstrumentReportDetail: PropTypes.array,
  InstrumentSchemes: PropTypes.array,
  onGetParticipantpayment: PropTypes.func,
  onGetDistrictList: PropTypes.func,
  // ongetcyclelist: PropTypes.func,
  match: PropTypes.object,
  ListDistrict: PropTypes.array,
  onGetDistrictList: PropTypes.func,
  onGetInstrumentReportList: PropTypes.func,
};
const mapStateToProps = (state) => {
  const cycleList = state.CycleList?.CycleList || [];
  const ListDistrict = state.ListDistrict?.ListDistrict || [];
  const InstrumentReportDetail = state.ListUnit?.InstrumentReportDetail || []; // <NS actual data
  const InstrumentParticipants = state.ListUnit?.InstrumentParticipants || [];
  const InstrumentSchemes = state.ListUnit?.InstrumentSchemes || [];

  return {
    userID: state.Account?.userID || null,
    CycleList: cycleList,
    PaymentSchemeList: state.PaymentScheme?.PaymentSchemeList || [],
    GetPayment: state.AddPayment?.GetPayment ?? [],
    ListDistrict,
    InstrumentReportDetail, // ✅ real data from Redux
    InstrumentParticipants, // ✅
    InstrumentSchemes, // ✅
  };
};

const mapDispatchToProps = (dispatch) => ({
  //  onGetParticipantpayment: () => dispatch(getParticipantPayment()),
  onGetParticipantpayment: (id) => dispatch(getParticipantPayment(id)),
  // ongetcyclelist: id => dispatch(getcyclelist(id)),
  onupdatePayment: (payload) => dispatch(updatePayment(payload)),
  ondeletePayment: (payload) => dispatch(deletePayment(payload)),
  onGetDistrictList: (id) => dispatch(getdistrictlist(id)),
  onGetInstrumentReportList: (id) => dispatch(getInstrumentReport(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParticipantPayments);
